import { DateRange } from '@angular/material/datepicker';
import moment from 'moment';

const PresetMonthTranslate: Map<number, string> = new Map([
	[1, 'DATEPICKER.AFTER_MONTH']
]),
	PresetDayTranslate: Map<number, string> = new Map([
		[0, 'TODAY'],
		[1, 'DATEPICKER.TOMORROW'],
		[2, 'DATEPICKER.AFTER_2DAYS'],
		[7, 'DATEPICKER.AFTER_WEEK']
	]);

export const DEFAULTS_PRESETS: Array<IPresetInput> = [
				{ type: 'day', count: 0 },
				{ type: 'day', count: 1 },
				{ type: 'day', count: 2 },
				{ type: 'day', count: 7 },
				{ type: 'month', count: 1 }
			],
			DEFAULTS_PRESETS_SCHEDULED: Array<IPresetInput> = [
				{ type: 'day', count: 1 },
				{ type: 'day', count: 2 },
				{ type: 'day', count: 7 },
				{ type: 'month', count: 1 }
			],
			DEFAULTS_RANGE_PRESETS: Array<IPresetInput> = [
				{
					type: 'day',
					count: 30,
					range: true
				},
				{
					type: 'day',
					count: 90,
					range: true
				},
				{
					type: '',
					count: 1,
					range: true,
					allPeriod: true
				},
				{
					type: 'month',
					count: 1,
					range: true,
					current: true
				},
				{
					type: 'year',
					count: 1,
					range: true,
					current: true
				},
			];

type PresetType = 'now' | 'day' | 'month' | 'year' | '';

export interface IPresetInput {
	type: PresetType;
	count: number;
	range?: boolean;
	current?: boolean;
	allPeriod?: boolean;
	defaultDate?: DateRange<Date>;
	customTranslateKey?: string;
}

export class Preset {
	type: PresetType;
	count: number;
	range: boolean;
	current: boolean;
	allPeriod: boolean;
	defaultDate: DateRange<Date>;
	customTranslateKey: string;
	active: boolean;
	disabled: boolean;

	constructor(preset: IPresetInput) {
		this.type = preset.type;
		this.count = preset.count;
		this.range = !!preset.range;
		this.current = !!preset.current;
		this.allPeriod = !!preset.allPeriod;
		this.defaultDate = preset.defaultDate;
		this.customTranslateKey = preset.customTranslateKey;
		this.active = false;
	}

	get date(): moment.Moment | DateRange<moment.Moment> {
		if (this.range) return this.rangeDate;
		const date = new Date();

		switch (this.type) {
			case 'day': {
				date.setDate(date.getDate() + this.count);
				return moment(date);
			}
			case 'month': {
				date.setMonth(date.getMonth() + this.count);
				return moment(date);
			}
			case 'year': {
				date.setFullYear(date.getFullYear() + this.count);
				return moment(date);
			}
		}
	}

	private get rangeDate(): DateRange<moment.Moment> {
		let dateFrom: Date = new Date(this.defaultDate.end);

		switch (this.type) {
			case 'day': {
				dateFrom.setDate(dateFrom.getDate() - this.count + 1);
				break;
			}
			case 'month': {
				dateFrom.setDate(1);
				break;
			}
			case 'year': {
				dateFrom.setMonth(0);
				dateFrom.setDate(1);
				break;
			}
			default: {
				if (this.allPeriod) dateFrom = this.defaultDate.start;
			}
		}
		return new DateRange<moment.Moment>(moment(dateFrom), moment(this.defaultDate.end));
	}

	get label(): { translate: string, count?: number } {
		if (this.customTranslateKey) {
			return { translate: this.customTranslateKey };
		}
		switch (this.type) {
			case 'day': {
				if (!this.range) return { translate: PresetDayTranslate.get(this.count) };
				return { translate: 'DATEPICKER.LAST_COUNT_DAYS', count: this.count };
			}
			case 'month': {
				if (!this.range) return { translate: PresetMonthTranslate.get(this.count) };
				return { translate: 'THIS_MONTH' };
			}
			case 'year': {
				if (this.range) return { translate: 'THIS_YEAR' };
				break;
			}
			default: {
				if (this.allPeriod) return { translate: 'ALL_PERIOD' };
			}
		}
	}

	get dateString(): string {
		if (this.range) {
			return `${this.rangeDate.start.toDate().toDateString()} - ${this.rangeDate.end.toDate().toDateString()}`;
		} else {
			return (this.date as moment.Moment).toDate().toDateString();
		}
	}
}